import { Component, OnInit } from '@angular/core';
import { AlertService } from './shared/services/alert.service';
import { IAlert } from './shared/interfaces/alert';
import { LoaderService } from './shared/services/loader.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  public alerts: IAlert[] = [];
  public showLoader: boolean = false;

  constructor(
    private alertService: AlertService,
    private loaderService: LoaderService
  ) {
    this.alerts = this.alertService.alerts;
  }

  ngOnInit(): void {
    this.loaderService.showVxLoader$.subscribe((loader: boolean) =>
      setTimeout(() => (this.showLoader = loader), 0)
    );
  }
}
